import React, { Component } from 'react';
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from "react-responsive-carousel";

import './ShowCarousel.css';


class ShowCarousel extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showCarousel: false,
      currentSlide: 0,
      showArrows: false,
      showStatus: false,
      showIndicators: false,
      infiniteLoop: true,
      showThumbs: false,
      useKeyboardArrows: false,
      autoPlay: true,
      stopOnHover: false,
      swipeable: false,
      dynamicHeight: false,
      emulateTouch: false,
      interval: 2400,
      transitionTime: 400
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if(prevState.showCarousel !== this.state.showCarousel && this.state.showCarousel) {
      this.updateCurrentSlide(1);
    }
  }

  updateCurrentSlide = (index) => {
      const { currentSlide } = this.state;

      if (currentSlide !== index) {
          this.setState({
              currentSlide: index,
          });
      }
  }

  showCarousel = () => {
    this.setState({showCarousel: true});
    this.updateCurrentSlide(0);
  }

  hideCarousel = () => {
    this.setState({showCarousel: false});
  }

  render() {
    var carouselImages = this.props.images ? this.props.images.map((e, i) => {
      return (
        <div key={i}>
          <img src={e} alt="" />
        </div>
      )
    }) : null;

    return (
      <div className="zoom-image"
        onMouseEnter={this.showCarousel.bind(this)}
        onMouseLeave={this.hideCarousel.bind(this)}>
        {this.state.showCarousel && this.props.images && this.props.images.length > 0 ?
          <Carousel {...this.state} className="show-carousel" selectedItem={this.state.currentSlide} onChange={this.updateCurrentSlide}>
            {carouselImages}
          </Carousel>
          : <img className="cover-image" src={this.props.mainImage} alt=""/>}
      </div>
      );
  }
}

export default ShowCarousel;
